<template>
  <v-card class="rounded-lg" flat outlined>
    <v-card-title>
      جزئیات کاربری
      <v-spacer/>
      <v-icon>mdi-information</v-icon>
    </v-card-title>

    <v-divider/>

    <v-list>
      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-code-less-than-or-equal</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="data.nid"/>
          <v-list-item-subtitle>کد ملی</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-book-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="data.mcode"/>
          <v-list-item-subtitle>شماره شناسنامه</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-human-male-boy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="data.father_name"/>
          <v-list-item-subtitle>نام پدر</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-note-text-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="data.postalCode"/>
          <v-list-item-subtitle>کد پستی</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-map-marker-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="data.address"/>
          <v-list-item-subtitle>آدرس محل سکونت</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-file</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="'تصویر شناسنامه'"/>
          <v-list-item-subtitle>
            <!--            <td class="clickable" @click="getUserFile(data.birthCertificatePicture)" v-text="'نمایش'">-->
            <!--              <v-chip v-text="'نمایش'"/>-->
            <!--            </td>-->
            ---
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-file</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="'تصویر کارت ملی'"/>
          <v-list-item-subtitle>
            <a :href="data.nidimage" target="_blank">
              <v-chip disabled x-small>
                نمایش
              </v-chip>
            </a>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list-item>
        <v-list-item-icon>
          <v-icon>mdi-shield-check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ jalalian(data.created_at) }}</v-list-item-title>
          <v-list-item-subtitle>تاریخ ثبت نام</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "dataDetails",

  props: ['data'],

  data: () => ({
    residenceProvince: null,
    residenceCity: null,
    employmentProvince: null,
    employmentCity: null,

  }),

  methods: {
    getUserFile(url) {
      let a = document.createElement('a');
      a.target = '_blank';
      a.href = this.uploadUrl + url;
      a.click();
    },

  }
}
</script>

<style scoped>

</style>
